import React from 'react';
import Table from '../../../components/tables/dynamicTable';
import ListURL from '../../../components/common/lists/ListURL';
import ToggleButton from '../../../components/common/ToggleButton';

const LaneviewToggleSection = ({
    toggleViewChange,
    toggle,
    rows,
    toggleObject,
    toggleValue,
    getTableToggle,
    toggleData
  }) => {
    const hasValidRows = rows.some(row => Object.keys(row).length > 0);
    if (toggleViewChange !== 'TMS' || !hasValidRows) return null;
  
    const productDetails = { data: toggleData };
    const trackingDetails = { data: toggleData };
    const podObject = { data: toggleData, listType: 'POD' };
    const bolObject = { data: toggleData, listType: 'BOL' };
  
    return (
      <div className="laneviewPageContentBottom">
        <div className="laneviewToggle">
          <ToggleButton 
            onClick={getTableToggle}
            toggleValue={toggleValue}
            toggleObject={toggleObject}
          />
        </div>
        <div className="laneviewDetailTables">
          {toggle === 'Product Details' && (
            <div className="laneviewProductDetails">
              <Table dataObject={productDetails} />
            </div>
          )}
          {toggle === 'Tracking Details' && (
            <div className="laneviewTrackingDetails">
              <Table dataObject={trackingDetails} />
            </div>
          )}
          {toggle === 'POD Attachment' && (
            <div className="laneviewPodList">
              <ListURL listObject={podObject} />
            </div>
          )}
          {toggle === 'BOL Attachment' && (
            <div className="laneviewBolList">
              <ListURL listObject={bolObject} />
            </div>
          )}
        </div>
      </div>
    );
  };
  
export default LaneviewToggleSection;
